import { createGuid, getMeta, getDynData } from "../../scripts/general_functions";
import { getImageByContentId } from "../../scripts/images";
//import { checkNested, getConfig, createGuid, getMeta, getDynData, testDynData, getDynDataOne } from "./general_functions";
import language from "../../scripts/translation";
import { campaigns, campaignItem } from "./campaigns_template";

export const getCampaigns = (load = 3, from = 0, callback) => {
    fetch(window.apiUrl + `/api/PublicContentApi/getcontentlistdescending/${client.clientId}/mal_dynamisk/${load}/${from}/Modified`).then(results => results.json()).then(data => {
        callback(data);
    });
}
export const campaignsFront = (maxItems = 1, moduleCardItemGuid = null, campaignDesign = "") => {

    let moduleGuid = createGuid();
    getCampaigns(100, 0, (data) => {
        let campaigns = [];
        let campCount = 0;

        if (data.totalCount > 0) {
            data.listOfContent.forEach(campaign => {
                let meta = getMeta(campaign);
                let details = getDynData(meta);
                let campGuid = createGuid();
                let addThisItem = moduleCardItemGuid == "" || campaign.contentId == moduleCardItemGuid;

                if(client?.moduleSettings?.campaigns?.introNewline === true && details.forsidetekst !== undefined) {
                    details.forsidetekst = details.forsidetekst.replace(/\n/g, "<br>");
                }
                if (addThisItem && details.forsidetittel) {
                    let image = ``;
                    let hasImage = false;
                    let cloudinaryUrl = "";

                    if (meta.imageContentId) {
                        hasImage = true;
                        image = `<div class="campaign__image_container"><img src='' id='campaign__${campGuid}' class="campaign__image" desc="${meta.imageDescription}" alt="${meta.imageDescription}"></div>`;
                        getImageByContentId(meta.imageContentId, (img) => {
                            if ($(document).width() < 768) {
                                //Mobile view
                                cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_345,h_345,c_fill/" + img.url;
                            }
                            else {
                                //Desktop view
                                if (maxItems == 1) {
                                    cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_180,h_180,c_fill/" + img.url;
                                }
                                else {
                                    cloudinaryUrl = "https://res.cloudinary.com/ssp/image/fetch/g_center,w_220,h_220,c_fill/" + img.url;
                                }
                            }
                            $(`#campaign__${campGuid}`).attr("src", cloudinaryUrl);
                        });
                    }

                    let link = `/artikkel/${campaign.nameInUrl}`;
                    let linktext = "Les mer her";
                    // let dynLink = getDynData(meta, "ea427bbd-f370-4f63-9769-2120a6a6fefd").res;
                    let dynLink = getDynData(meta, "dddc6cac-9579-4d59-9f52-c3a85ca05473").res;  // "Lenke fra forsideboks (valgfri)"
                    let sortorder = details.sorteringsrekkefolge;// getDynData(meta, "sortorder").res;
                    if (dynLink) {
                        link = dynLink; //`<span class="campaign__link">Gå til siden</span>`;
                        linktext = language("CAMPAIGN_GOTOPAGE");
                    }

                    campCount++;
                    campaigns.push({
                        item: 
                            campaignItem({
                                link: link,
                                image: image,
                                forsidetittel: details.forsidetittel,
                                forsidetekst: details.forsidetekst,
                                order: sortorder
                            }),
                        order: sortorder
                    });
                }
            });
        }

        //if(sorting) {
            //campaigns.sort(function(a,b) => (a.))
        //}
        let sortedCampaigns = campaigns.sort((a, b) => {
        if (a.order < b.order) return -1
        if (a.order > b.order) return 1
        return 0
        })
        
        sortedCampaigns = sortedCampaigns.slice(0, maxItems);

        if (campaigns.length < 1) {
            $(`#campaigns${moduleGuid}>div`).html("");
        }
        else {
            //campaigns = campaigns.join("");
            // $("#campaigns").html(campaigns.join(""));
            let joinedCampaigns=campaigns.map(e => e.item).join("")
            $(`#campaigns${moduleGuid}`).html(joinedCampaigns);
        }
        if (campaigns.length == 1) { $(`#campaigns${moduleGuid}`).addClass("single"); }
    })


    return campaigns({
        moduleID:       moduleGuid,
        campaignDesign: campaignDesign,
        maxItems:       maxItems
    });

}
